export const civilStatusOptions = [
  {
    value: '1',
    label: 'Single'
  },
  {
    value: '2',
    label: 'Married'
  },
  {
    value: '3',
    label: 'Separated'
  },
  {
    value: '4',
    label: 'Divorced/Annuled'
  },
  {
    value: '5',
    label: 'Widow/er'
  }
];

export const sourceOfFundsOptions = [
  {
    value: '1',
    label: 'Employment'
  },
  {
    value: '2',
    label: 'Business'
  },
  {
    value: '3',
    label: 'Both'
  }
];


export const busiDocOptions = [
  {
    value: '1',
    label: 'DTI Business Registration Certificate'
  },
  {
    value: '2',
    label: 'BIR Certificate of Registration'
  },
  {
    value: '3',
    label: "Local government permits and licenses (e.g. Mayor's Permit, etc.)"
  }
];

export const birthCountryOptions = [{"label":"Philippines","value":"Philippines"},]

//export const birthCityOptions = [{"label":"ABRA","value":"1"},{"label":"AURORA","value":"2"},{"label":"ALBAY","value":"3"},{"label":"AKLAN","value":"4"},{"label":"ANTIQUE","value":"5"},{"label":"AGUSAN DEL SUR","value":"6"},{"label":"AGUSAN DEL NORTE","value":"7"},{"label":"BATAAN","value":"8"},{"label":"BENGUET","value":"9"},{"label":"BULACAN","value":"10"},{"label":"BATANES","value":"11"},{"label":"BATANGAS","value":"12"},{"label":"BOHOL","value":"13"},{"label":"BILIRAN","value":"14"},{"label":"BASILAN","value":"15"},{"label":"BUKIDNON","value":"16"},{"label":"CALOOCAN","value":"17"},{"label":"CAGAYAN","value":"18"},{"label":"CAVITE","value":"19"},{"label":"CAMARINES SUR","value":"20"},{"label":"CAMARINES NORTE","value":"21"},{"label":"CATANDUANES","value":"22"},{"label":"CAPIZ","value":"23"},{"label":"CEBU","value":"24"},{"label":"COMPOSTELA VALLEY","value":"25"},{"label":"CAMIGUIN","value":"26"},{"label":"DAVAO DEL SUR","value":"27"},{"label":"DAVAO DEL NORTE","value":"28"},{"label":"DAVAO ORIENTAL","value":"29"},{"label":"EASTERN SAMAR","value":"30"},{"label":"GUIMARAS","value":"31"},{"label":"ILOCUS SUR","value":"32"},{"label":"ILOCUS NORTE","value":"33"},{"label":"ISABELA","value":"34"},{"label":"IFUGAO","value":"35"},{"label":"ILOILO","value":"36"},{"label":"KALINGA-APAYAO","value":"37"},{"label":"LAS PINAS","value":"38"},{"label":"LA UNION","value":"39"},{"label":"LAGUNA","value":"40"},{"label":"LEYTE","value":"41"},{"label":"LANAO DEL NORTE","value":"42"},{"label":"LANAO DEL SUR","value":"43"},{"label":"MAKATI CITY","value":"44"},{"label":"MANILA","value":"45"},{"label":"MALABON","value":"46"},{"label":"MANDALUYONG CITY","value":"47"},{"label":"MUNTINLUPA","value":"48"},{"label":"MARIKINA CITY","value":"49"},{"label":"MOUNTAIN PROVINCE","value":"50"},{"label":"MARINDUQUE","value":"51"},{"label":"MINDORO OCCIDENTAL","value":"52"},{"label":"MINDORO ORIENTAL","value":"53"},{"label":"MASBATE","value":"54"},{"label":"MISAMIS OCCIDENTAL","value":"55"},{"label":"MISAMIS ORIENTAL","value":"56"},{"label":"MAGUINDANAO","value":"57"},{"label":"NAVOTAS","value":"58"},{"label":"NUEVA ECIJA","value":"59"},{"label":"NUEVA VIZCAYA","value":"60"},{"label":"NEGROS OCCIDENTAL","value":"61"},{"label":"NEGROS ORIENTAL","value":"62"},{"label":"NORTHERN SAMAR","value":"63"},{"label":"NORTH COTABATO","value":"64"},{"label":"PASAY CITY","value":"65"},{"label":"PASIG","value":"66"},{"label":"PATEROS","value":"67"},{"label":"PARANAQUE","value":"68"},{"label":"PAMPANGA","value":"69"},{"label":"PANGASINAN","value":"70"},{"label":"PALAWAN","value":"71"},{"label":"QUEZON CITY","value":"72"},{"label":"QUIRINO","value":"73"},{"label":"QUEZON","value":"74"},{"label":"RIZAL","value":"75"},{"label":"ROMBLON","value":"76"},{"label":"SAN JUAN","value":"77"},{"label":"SORSOGON","value":"78"},{"label":"SIQUIJOR","value":"79"},{"label":"SOUTHERN LEYTE","value":"80"},{"label":"SULU","value":"81"},{"label":"SURIGAO DEL SUR","value":"82"},{"label":"SURIGAO DEL NORTE","value":"83"},{"label":"SOUTH COTOBATO","value":"84"},{"label":"SARANGANI","value":"85"},{"label":"SULTAN KUDARAT","value":"86"},{"label":"TAGUIG","value":"87"},{"label":"TARLAC","value":"88"},{"label":"TAWI-TAWI","value":"89"},{"label":"VALENZUELA","value":"90"},{"label":"WESTERN SAMAR","value":"91"},{"label":"ZAMBALES","value":"92"},{"label":"ZAMBOANGA DEL SUR","value":"93"},{"label":"ZAMBOANGA DEL NORTE","value":"94"}]
export const birthCityOptions = []

export const idTypeOptions = [{"label":"Driver’s License","value":"1"},{"label":"Passport","value":"2"},{"label":"Philippine Postal ID","value":"3"},{"label":"Senior Citizen ID","value":"4"},{"label":"PRC ID","value":"5"},{"label":"SSS / GSIS ID","value":"6"},{"label":"TIN ID","value":"7"},{"label":"Voter’s ID","value":"8"},{"label":"Health Insurance Card ng Bayan issued by PhilHealth Insurance Corporation","value":"9"},{"label":"Overseas Workers Welfare Administration (OWWA)","value":"10"},{"label":"Overseas Filipino Workers (OFW) ID","value":"11"},{"label":"Government Office and GOCC ID (e.g. Armed Forces of the Philippines [AFP], Home Development\r\nMutual Fund [HDMF] IDs)","value":"12"},{"label":"Department of Social Welfare and Development","value":"13"},{"label":"Integrated Bar of the Philippines (IBP) ID","value":"14"},{"label":"Company IDs issued by private entities or institutions registered with or supervised or regulated by BSP,\r\nSEC or IC.","value":"15"},{"label":"Maritime Industry Authority (MARINA) ID","value":"16"}]

export const merchantNatureOptions = [{"label":"Service","value":"1"},{"label":"Food","value":"2"},{"label":"Retail","value":"3"}]

export const yearsNumberOptions = [{"label":"less than a year","value":"1"}, {"label":"less than 2 years","value":"2"}, {"label":"2-3 years","value":"3"}, {"label":"4-5 years","value":"4"},{"label":"Over 5 years","value":"5"}]

export const bankOptions = [{"label":"BDO Unibank","value":"1"},{"label":"BDO Network Bank","value":"2"},{"label":"I don’t have a BDO Settlement account","value":"3"}]

export const deliveryAddressOptions = [{"label":"Home","value":"1"},{"label":"Business","value":"2"}]

//export const citizenShipOptions = [{"label":"Filipino","value":"1"},{"label":"Foreigner","value":"2"}]

export const acquirerOptions = [{"label":"Yes","value":"1"},{"label":"No","value":"2"}]

export const citizenShipOptions = [
  {
      "label": "Philippines",
      "value": "Philippines"
  },
  {
      "label": "Afghanistan",
      "value": "Afghanistan"
  },
  {
      "label": "Aland Islands",
      "value": "Aland Islands"
  },
  {
      "label": "Albania",
      "value": "Albania"
  },
  {
      "label": "Algeria",
      "value": "Algeria"
  },
//   {
//       "label": "American Samoa",
//       "value": "American Samoa"
//   },
  {
      "label": "Andorra",
      "value": "Andorra"
  },
  {
      "label": "Angola",
      "value": "Angola"
  },
  {
      "label": "Anguilla",
      "value": "Anguilla"
  },
  {
      "label": "Antarctica",
      "value": "Antarctica"
  },
  {
      "label": "Antigua and Barbuda",
      "value": "Antigua and Barbuda"
  },
  {
      "label": "Argentina",
      "value": "Argentina"
  },
  {
      "label": "Armenia",
      "value": "Armenia"
  },
  {
      "label": "Aruba",
      "value": "Aruba"
  },
  {
      "label": "Australia",
      "value": "Australia"
  },
  {
      "label": "Austria",
      "value": "Austria"
  },
  {
      "label": "Azerbaijan",
      "value": "Azerbaijan"
  },
  {
      "label": "Bahamas",
      "value": "Bahamas"
  },
  {
      "label": "Bahrain",
      "value": "Bahrain"
  },
  {
      "label": "Bangladesh",
      "value": "Bangladesh"
  },
  {
      "label": "Barbados",
      "value": "Barbados"
  },
  {
      "label": "Belarus",
      "value": "Belarus"
  },
  {
      "label": "Belgium",
      "value": "Belgium"
  },
  {
      "label": "Belize",
      "value": "Belize"
  },
  {
      "label": "Benin",
      "value": "Benin"
  },
  {
      "label": "Bermuda",
      "value": "Bermuda"
  },
  {
      "label": "Bhutan",
      "value": "Bhutan"
  },
  {
      "label": "Bolivia",
      "value": "Bolivia"
  },
  {
      "label": "Bonaire, Sint Eustatius and Saba",
      "value": "Bonaire, Sint Eustatius and Saba"
  },
  {
      "label": "Bosnia and Herzegovina",
      "value": "Bosnia and Herzegovina"
  },
  {
      "label": "Botswana",
      "value": "Botswana"
  },
  {
      "label": "Bouvet Island",
      "value": "Bouvet Island"
  },
  {
      "label": "Brazil",
      "value": "Brazil"
  },
  {
      "label": "British Indian Ocean Territory",
      "value": "British Indian Ocean Territory"
  },
  {
      "label": "Brunei Darussalam",
      "value": "Brunei Darussalam"
  },
  {
      "label": "Bulgaria",
      "value": "Bulgaria"
  },
  {
      "label": "Burkina Faso",
      "value": "Burkina Faso"
  },
  {
      "label": "Burundi",
      "value": "Burundi"
  },
  {
      "label": "Cambodia",
      "value": "Cambodia"
  },
  {
      "label": "Cameroon",
      "value": "Cameroon"
  },
  {
      "label": "Canada",
      "value": "Canada"
  },
  {
      "label": "Cape Verde",
      "value": "Cape Verde"
  },
  {
      "label": "Cayman Islands",
      "value": "Cayman Islands"
  },
  {
      "label": "Central African Republic",
      "value": "Central African Republic"
  },
  {
      "label": "Chad",
      "value": "Chad"
  },
  {
      "label": "Chile",
      "value": "Chile"
  },
  {
      "label": "China",
      "value": "China"
  },
  {
      "label": "Christmas Island",
      "value": "Christmas Island"
  },
  {
      "label": "Cocos (Keeling) Islands",
      "value": "Cocos (Keeling) Islands"
  },
  {
      "label": "Colombia",
      "value": "Colombia"
  },
  {
      "label": "Comoros",
      "value": "Comoros"
  },
  {
      "label": "Congo",
      "value": "Congo"
  },
  {
      "label": "Congo, The Democratic Republic of",
      "value": "Congo, The Democratic Republic of"
  },
  {
      "label": "Cook Islands",
      "value": "Cook Islands"
  },
  {
      "label": "Costa Rica",
      "value": "Costa Rica"
  },
  {
      "label": "Cote d'Ivoire",
      "value": "Cote d'Ivoire"
  },
  {
      "label": "Croatia",
      "value": "Croatia"
  },
  {
      "label": "Cuba",
      "value": "Cuba"
  },
  {
      "label": "Curaçao",
      "value": "Curaçao"
  },
  {
      "label": "Cyprus",
      "value": "Cyprus"
  },
  {
      "label": "Czechia",
      "value": "Czechia"
  },
  {
      "label": "Denmark",
      "value": "Denmark"
  },
  {
      "label": "Djibouti",
      "value": "Djibouti"
  },
  {
      "label": "Dominica",
      "value": "Dominica"
  },
  {
      "label": "Dominican Republic",
      "value": "Dominican Republic"
  },
  {
      "label": "Ecuador",
      "value": "Ecuador"
  },
  {
      "label": "Egypt",
      "value": "Egypt"
  },
  {
      "label": "El Salvador",
      "value": "El Salvador"
  },
  {
      "label": "Equatorial Guinea",
      "value": "Equatorial Guinea"
  },
  {
      "label": "Eritrea",
      "value": "Eritrea"
  },
  {
      "label": "Estonia",
      "value": "Estonia"
  },
  {
      "label": "Ethiopia",
      "value": "Ethiopia"
  },
  {
      "label": "Falkland Islands (Malvinas)",
      "value": "Falkland Islands (Malvinas)"
  },
  {
      "label": "Faroe Islands",
      "value": "Faroe Islands"
  },
  {
      "label": "Fiji",
      "value": "Fiji"
  },
  {
      "label": "Finland",
      "value": "Finland"
  },
  {
      "label": "France",
      "value": "France"
  },
  {
      "label": "French Guiana",
      "value": "French Guiana"
  },
  {
      "label": "French Polynesia",
      "value": "French Polynesia"
  },
  {
      "label": "French Southern Territories",
      "value": "French Southern Territories"
  },
  {
      "label": "Gabon",
      "value": "Gabon"
  },
  {
      "label": "Gambia",
      "value": "Gambia"
  },
  {
      "label": "Georgia",
      "value": "Georgia"
  },
  {
      "label": "Germany",
      "value": "Germany"
  },
  {
      "label": "Ghana",
      "value": "Ghana"
  },
  {
      "label": "Gibraltar",
      "value": "Gibraltar"
  },
  {
      "label": "Greece",
      "value": "Greece"
  },
  {
      "label": "Greenland",
      "value": "Greenland"
  },
  {
      "label": "Grenada",
      "value": "Grenada"
  },
  {
      "label": "Guadeloupe",
      "value": "Guadeloupe"
  },
  {
      "label": "Guam",
      "value": "Guam"
  },
  {
      "label": "Guatemala",
      "value": "Guatemala"
  },
  {
      "label": "Guernsey",
      "value": "Guernsey"
  },
  {
      "label": "Guinea",
      "value": "Guinea"
  },
  {
      "label": "Guinea-Bissau",
      "value": "Guinea-Bissau"
  },
  {
      "label": "Guyana",
      "value": "Guyana"
  },
  {
      "label": "Haiti",
      "value": "Haiti"
  },
  {
      "label": "Heard and Mc Donald Islands",
      "value": "Heard and Mc Donald Islands"
  },
  {
      "label": "Holy See (Vatican City State)",
      "value": "Holy See (Vatican City State)"
  },
  {
      "label": "Honduras",
      "value": "Honduras"
  },
  {
      "label": "Hong Kong",
      "value": "Hong Kong"
  },
  {
      "label": "Hungary",
      "value": "Hungary"
  },
  {
      "label": "Iceland",
      "value": "Iceland"
  },
  {
      "label": "India",
      "value": "India"
  },
  {
      "label": "Indonesia",
      "value": "Indonesia"
  },
  {
      "label": "Iran, Islamic Republic of",
      "value": "Iran, Islamic Republic of"
  },
  {
      "label": "Iraq",
      "value": "Iraq"
  },
  {
      "label": "Ireland",
      "value": "Ireland"
  },
  {
      "label": "Isle of Man",
      "value": "Isle of Man"
  },
  {
      "label": "Israel",
      "value": "Israel"
  },
  {
      "label": "Italy",
      "value": "Italy"
  },
  {
      "label": "Jamaica",
      "value": "Jamaica"
  },
  {
      "label": "Japan",
      "value": "Japan"
  },
  {
      "label": "Jersey",
      "value": "Jersey"
  },
  {
      "label": "Jordan",
      "value": "Jordan"
  },
  {
      "label": "Kazakstan",
      "value": "Kazakstan"
  },
  {
      "label": "Kenya",
      "value": "Kenya"
  },
  {
      "label": "Kiribati",
      "value": "Kiribati"
  },
  {
      "label": "Korea, Democratic People's Republic of",
      "value": "Korea, Democratic People's Republic of"
  },
  {
      "label": "Korea, Republic of",
      "value": "Korea, Republic of"
  },
  {
      "label": "Kosovo (temporary code)",
      "value": "Kosovo (temporary code)"
  },
  {
      "label": "Kuwait",
      "value": "Kuwait"
  },
  {
      "label": "Kyrgyzstan",
      "value": "Kyrgyzstan"
  },
  {
      "label": "Lao, People's Democratic Republic",
      "value": "Lao, People's Democratic Republic"
  },
  {
      "label": "Latvia",
      "value": "Latvia"
  },
  {
      "label": "Lebanon",
      "value": "Lebanon"
  },
  {
      "label": "Lesotho",
      "value": "Lesotho"
  },
  {
      "label": "Liberia",
      "value": "Liberia"
  },
  {
      "label": "Libyan Arab Jamahiriya",
      "value": "Libyan Arab Jamahiriya"
  },
  {
      "label": "Liechtenstein",
      "value": "Liechtenstein"
  },
  {
      "label": "Lithuania",
      "value": "Lithuania"
  },
  {
      "label": "Luxembourg",
      "value": "Luxembourg"
  },
  {
      "label": "Macao",
      "value": "Macao"
  },
  {
      "label": "Macedonia, The Former Yugoslav Republic Of",
      "value": "Macedonia, The Former Yugoslav Republic Of"
  },
  {
      "label": "Madagascar",
      "value": "Madagascar"
  },
  {
      "label": "Malawi",
      "value": "Malawi"
  },
  {
      "label": "Malaysia",
      "value": "Malaysia"
  },
  {
      "label": "Maldives",
      "value": "Maldives"
  },
  {
      "label": "Mali",
      "value": "Mali"
  },
  {
      "label": "Malta",
      "value": "Malta"
  },
  {
      "label": "Marshall Islands",
      "value": "Marshall Islands"
  },
  {
      "label": "Martinique",
      "value": "Martinique"
  },
  {
      "label": "Mauritania",
      "value": "Mauritania"
  },
  {
      "label": "Mauritius",
      "value": "Mauritius"
  },
  {
      "label": "Mayotte",
      "value": "Mayotte"
  },
  {
      "label": "Mexico",
      "value": "Mexico"
  },
  {
      "label": "Micronesia, Federated States of",
      "value": "Micronesia, Federated States of"
  },
  {
      "label": "Moldova, Republic of",
      "value": "Moldova, Republic of"
  },
  {
      "label": "Monaco",
      "value": "Monaco"
  },
  {
      "label": "Mongolia",
      "value": "Mongolia"
  },
  {
      "label": "Montenegro",
      "value": "Montenegro"
  },
  {
      "label": "Montserrat",
      "value": "Montserrat"
  },
  {
      "label": "Morocco",
      "value": "Morocco"
  },
  {
      "label": "Mozambique",
      "value": "Mozambique"
  },
  {
      "label": "Myanmar",
      "value": "Myanmar"
  },
  {
      "label": "Namibia",
      "value": "Namibia"
  },
  {
      "label": "Nauru",
      "value": "Nauru"
  },
  {
      "label": "Nepal",
      "value": "Nepal"
  },
  {
      "label": "Netherlands",
      "value": "Netherlands"
  },
  {
      "label": "Netherlands Antilles",
      "value": "Netherlands Antilles"
  },
  {
      "label": "New Caledonia",
      "value": "New Caledonia"
  },
  {
      "label": "New Zealand",
      "value": "New Zealand"
  },
  {
      "label": "Nicaragua",
      "value": "Nicaragua"
  },
  {
      "label": "Niger",
      "value": "Niger"
  },
  {
      "label": "Nigeria",
      "value": "Nigeria"
  },
  {
      "label": "Niue",
      "value": "Niue"
  },
  {
      "label": "Norfolk Island",
      "value": "Norfolk Island"
  },
  {
      "label": "Northern Mariana Islands",
      "value": "Northern Mariana Islands"
  },
  {
      "label": "Norway",
      "value": "Norway"
  },
  {
      "label": "Oman",
      "value": "Oman"
  },
  {
      "label": "Pakistan",
      "value": "Pakistan"
  },
  {
      "label": "Palau",
      "value": "Palau"
  },
  {
      "label": "Palestinian Territory, Occupied",
      "value": "Palestinian Territory, Occupied"
  },
  {
      "label": "Panama",
      "value": "Panama"
  },
  {
      "label": "Papua New Guinea",
      "value": "Papua New Guinea"
  },
  {
      "label": "Paraguay",
      "value": "Paraguay"
  },
  {
      "label": "Peru",
      "value": "Peru"
  },
  {
      "label": "Pitcairn",
      "value": "Pitcairn"
  },
  {
      "label": "Poland",
      "value": "Poland"
  },
  {
      "label": "Portugal",
      "value": "Portugal"
  },
  {
      "label": "Puerto Rico",
      "value": "Puerto Rico"
  },
  {
      "label": "Qatar",
      "value": "Qatar"
  },
  {
      "label": "Republic of Serbia",
      "value": "Republic of Serbia"
  },
  {
      "label": "Reunion",
      "value": "Reunion"
  },
  {
      "label": "Romania",
      "value": "Romania"
  },
  {
      "label": "Russia Federation",
      "value": "Russia Federation"
  },
  {
      "label": "Rwanda",
      "value": "Rwanda"
  },
  {
      "label": "Saint Barthélemy",
      "value": "Saint Barthélemy"
  },
  {
      "label": "Saint Helena",
      "value": "Saint Helena"
  },
  {
      "label": "Saint Kitts & Nevis",
      "value": "Saint Kitts & Nevis"
  },
  {
      "label": "Saint Lucia",
      "value": "Saint Lucia"
  },
  {
      "label": "Saint Martin",
      "value": "Saint Martin"
  },
  {
      "label": "Saint Pierre and Miquelon",
      "value": "Saint Pierre and Miquelon"
  },
  {
      "label": "Saint Vincent and the Grenadines",
      "value": "Saint Vincent and the Grenadines"
  },
  {
      "label": "Samoa",
      "value": "Samoa"
  },
  {
      "label": "San Marino",
      "value": "San Marino"
  },
  {
      "label": "Sao Tome and Principe",
      "value": "Sao Tome and Principe"
  },
  {
      "label": "Saudi Arabia",
      "value": "Saudi Arabia"
  },
  {
      "label": "Senegal",
      "value": "Senegal"
  },
  {
      "label": "Serbia and Montenegro",
      "value": "Serbia and Montenegro"
  },
  {
      "label": "Seychelles",
      "value": "Seychelles"
  },
  {
      "label": "Sierra Leone",
      "value": "Sierra Leone"
  },
  {
      "label": "Singapore",
      "value": "Singapore"
  },
  {
      "label": "Sint Maarten",
      "value": "Sint Maarten"
  },
  {
      "label": "Slovakia",
      "value": "Slovakia"
  },
  {
      "label": "Slovenia",
      "value": "Slovenia"
  },
  {
      "label": "Solomon Islands",
      "value": "Solomon Islands"
  },
  {
      "label": "Somalia",
      "value": "Somalia"
  },
  {
      "label": "South Africa",
      "value": "South Africa"
  },
  {
      "label": "South Georgia & The South Sandwich Islands",
      "value": "South Georgia & The South Sandwich Islands"
  },
  {
      "label": "South Sudan",
      "value": "South Sudan"
  },
  {
      "label": "Spain",
      "value": "Spain"
  },
  {
      "label": "Sri Lanka",
      "value": "Sri Lanka"
  },
  {
      "label": "Sudan",
      "value": "Sudan"
  },
  {
      "label": "Suriname",
      "value": "Suriname"
  },
  {
      "label": "Svalbard and Jan Mayen",
      "value": "Svalbard and Jan Mayen"
  },
  {
      "label": "Swaziland",
      "value": "Swaziland"
  },
  {
      "label": "Sweden",
      "value": "Sweden"
  },
  {
      "label": "Switzerland",
      "value": "Switzerland"
  },
  {
      "label": "Syrian Arab Republic",
      "value": "Syrian Arab Republic"
  },
  {
      "label": "Taiwan, Province of China",
      "value": "Taiwan, Province of China"
  },
  {
      "label": "Tajikistan",
      "value": "Tajikistan"
  },
  {
      "label": "Tanzania, United Republic of",
      "value": "Tanzania, United Republic of"
  },
  {
      "label": "Thailand",
      "value": "Thailand"
  },
  {
      "label": "Timor-Leste",
      "value": "Timor-Leste"
  },
  {
      "label": "Togo",
      "value": "Togo"
  },
  {
      "label": "Tokelau",
      "value": "Tokelau"
  },
  {
      "label": "Tonga",
      "value": "Tonga"
  },
  {
      "label": "Trinidad and Tobago",
      "value": "Trinidad and Tobago"
  },
  {
      "label": "Tunisia",
      "value": "Tunisia"
  },
  {
      "label": "Turvalue",
      "value": "Turvalue"
  },
  {
      "label": "Turkish Rep N Cyprus (temporary code)",
      "value": "Turkish Rep N Cyprus (temporary code)"
  },
  {
      "label": "Turkmenistan",
      "value": "Turkmenistan"
  },
  {
      "label": "Turks and Caicos Islands",
      "value": "Turks and Caicos Islands"
  },
  {
      "label": "Tuvalu",
      "value": "Tuvalu"
  },
  {
      "label": "Uganda",
      "value": "Uganda"
  },
  {
      "label": "Ukraine",
      "value": "Ukraine"
  },
  {
      "label": "United Arab Emirates",
      "value": "United Arab Emirates"
  },
  {
      "label": "United Kingdom",
      "value": "United Kingdom"
  },
  {
      "label": "United States",
      "value": "United States"
  },
  {
      "label": "United States Minor Outlying Islands",
      "value": "United States Minor Outlying Islands"
  },
  {
      "label": "Uruguay",
      "value": "Uruguay"
  },
  {
      "label": "Uzbekistan",
      "value": "Uzbekistan"
  },
  {
      "label": "Vanuatu",
      "value": "Vanuatu"
  },
  {
      "label": "Venezuela",
      "value": "Venezuela"
  },
  {
      "label": "Vietnam",
      "value": "Vietnam"
  },
  {
      "label": "Virgin Islands, British",
      "value": "Virgin Islands, British"
  },
  {
      "label": "Virgin Islands, U.S.",
      "value": "Virgin Islands, U.S."
  },
  {
      "label": "Wallis and Futuna",
      "value": "Wallis and Futuna"
  },
  {
      "label": "Western Sahara",
      "value": "Western Sahara"
  },
  {
      "label": "Yemen",
      "value": "Yemen"
  },
  {
      "label": "Zambia",
      "value": "Zambia"
  },
  {
      "label": "Zimbabwe",
      "value": "Zimbabwe"
  }
]


